// extracted by mini-css-extract-plugin
export default {"DotSeparator":"cBNQEDWjW94AhaIMO0Zk"};